module.exports = __webpack_public_path__ + "img/im-vergleich.a8cf869.webp";